<template>
    <performance-common-dialog
        :title="'合同外线路'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'460px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-position="right"
                :model="form"
                label-width="135px"
                :rules="rules"
            >
                <el-form-item label="合同外场景：" prop="contractOut">
                    <otpSelect
                        :optionNum="'TMS_CONTRACT_SITUATION_KITCHEN'"
                        @getSelectValue="getSelectValue"
                        :mValue="form.contractOut"
                        placeholder="请选择合同外场景"
                        :prop="'contractOut'"
                    >
                    </otpSelect>
                </el-form-item>
                <p v-if="componentsData.freightBasis !== '40' && +form.contractOut === 3 && +componentsData.natureType === 1" class="toolTips">
                    注：本单为供应商竞价单，发车前请补充发起成本合同外的审批。
                </p>

                <el-form-item label="运输成本(元)：" prop="transportationCost" v-if="form.contractOut !== '3'">
                    <el-input
                        clearable
                        :disabled="disableFlag"
                        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                        maxlength="10"
                        v-model.trim="form.transportationCost"
                    ></el-input>
                </el-form-item>
                <p v-if="form.contractOut === '1'" class="toolTips">注：填写的成本仅作审批参考，实际发车成本会取合同价格计费。</p>

                <el-form-item
                    label="运输收入(元)："
                    prop="transportationIncome"
                >
                    <el-input
                        clearable
                        :disabled="disableFlag"
                        v-model.trim="form.transportationIncome"
                        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                        maxlength="10"
                    ></el-input>
                </el-form-item>
                <p v-if="form.contractOut === '2'" class="toolTips">注：填写的收入仅作审批参考，实际发车收入会取合同价格计费。</p>

                <div
                    style="margin: 25px"
                    v-if="componentsData.freightBasis === '40'"
                >
                    <el-checkbox v-model="storageOrder" disabled
                        >包含搬仓订单，允许运输收入填写0</el-checkbox
                    >
                </div>

                <el-form-item label="现汇税率(%)：" prop="taxRate">
                    <otpAdvance
                        :mValue="form.taxRate"
                        :disabled="disableFlag"
                        :prop="'taxRate'"
                        @getAdvanceValue="getTaxRateValue"
                        :params="taxRateLists"
                    >
                    </otpAdvance>
                </el-form-item>

                <el-form-item label="厨热订单数：" prop="kitchenCount" v-if="form.contractOut === '3'">
                    <el-input
                        readonly
                        disabled
                        v-model.trim="kitchenCount"
                    ></el-input>
                </el-form-item>

                <el-form-item label="目标成本(元)：" v-if="form.contractOut !== '3'">
                    <el-input
                        clearable
                        disabled
                        v-model.trim="form.standardCost"
                    ></el-input>
                </el-form-item>

                <el-form-item
                    label="搬仓事前工作流号"
                    prop="iflowId"
                    v-if="componentsData.freightBasis === '40'"
                >
                    <el-input
                        clearable
                        maxlength="32"
                        v-model="form.iflowId"
                        placeholder="请填写对应的“06040309搬仓方案及费用流程审批号”"
                    ></el-input>
                </el-form-item>

                <p
                    style="margin-left: 20px"
                    v-if="componentsData.freightBasis === '40'"
                >
                    说明：起草搬仓工作流后，则不需要合同外审批
                </p>

                <el-form-item
                    label="下游会计主体："
                    prop="transUnitName"
                    v-if="['0', '2'].includes(form.contractOut)"
                >
                    <otpAdvance
                        :disabled="!!componentsData.iflowStatus"
                        :formData="form"
                        :prop="'transUnitName'"
                        :mValue="form.transUnitName"
                        @getAdvanceValue="getVehicleCardValue"
                        :params="transUnitName"
                    ></otpAdvance>
                </el-form-item>
                <p v-if="['0', '2'].includes(form.contractOut)" class="toolTips">注：所选合同号决定付款的会计主体和付款条件，请核实清楚。</p>

                <el-form-item
                    label="成本付款条件："
                    v-if="['0', '2'].includes(form.contractOut)"
                >
                    {{ dictData[form.paymentTerms + ''] }}
                </el-form-item>

                <el-form-item
                    label="供应商合同单据编码："
                    v-if="['0', '2'].includes(form.contractOut)"
                >
                    {{ form.transportContractNo }}
                </el-form-item>

                <div class="bottom-btn">
                    <el-button
                        type="primary"
                        :loading="loading"
                        @click="saveBtn"
                    >
                        保存
                    </el-button>
                </div>
            </el-form>
        </template>
    </performance-common-dialog>
</template>
<script>
import otpSelect from '@/components/lots/otpSelect';
import otpAdvance from '@/components/lots/otpAdvance';
import { dictWithUrl } from '@/components/lots/api.js';
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import { createWhitoutzdc, iflowCreateKitchen, lsrmCostSearch } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';

export default {
    name: 'dispatchOrder',
    components: { PerformanceCommonDialog, otpAdvance, otpSelect },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            form: {
                siteCode: '', // 服务平台编码
                carrierCode: '', // 供应商编码
                transportationCost: '', // 运输成本
                standardCost: '', // 目标成本
                taxRate: '', // 现汇税率
                iflowId: '', // 搬仓事前工作流号
                transportationIncome: '', // 运输收入
                transUnitCode: '', // 会计主体编码
                transUnitName: '', // 会计主体名称
                paymentTerms: '', // 成本付款条件
                transportContractNo: '', // 供应商合同编码
                transportContractName: '', // 供应商合同名称
                supplierBusinessType: '', // 供应商业务类型
                contractOut: '' // 合同外场景
            },
            dictData: [],
            rules: {
                contractOut: [
                    {
                        validator: this.validateContractOut,
                        required: true,
                        trigger: ['blur', 'change']
                    }
                ],
                transportationCost: [
                    {
                        validator: this.validateTransportationCost,
                        required: true,
                        trigger: 'blur'
                    }
                ],
                transportationIncome: [
                    {
                        validator: this.validateTransportationIncome,
                        required: true,
                        trigger: 'blur'
                    }
                ],
                taxRate: [
                    {
                        required: true,
                        message: '税率不能为空',
                        trigger: 'blur'
                    }
                ],
                iflowId: [
                    {
                        required: true,
                        message: '搬仓事前工作流号不能为空',
                        trigger: 'blur'
                    }
                ],
                transUnitName: [
                    {
                        required: true,
                        message: '会计主体不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            taxRateLists: {
                name: '请输入税率',
                advanceLabel: '税率',
                value: 'taxRate',
                advanceConfig: [
                    { prop: 'percentageRateStr', 'value': '税率百分比' },
                    { prop: 'taxRateCode', 'value': '税率代码' }
                ],
                tableConfig: [
                    { prop: 'percentageRate', 'value': '税率百分比' },
                    { prop: 'taxRateCode', 'value': '税率代码' }
                ],
                advanceUrl: 'efTaxRate/popTaxRate/in',
                cbParams: ['percentageRate#taxRate']
            },
            transUnitName: {
                name: '请输入会计主体',
                advanceLabel: '会计主体',
                value: 'transUnitName',
                dialogWidth: '1000px',
                mode: 'EbPlace',
                advanceConfig: [
                    { prop: 'accountCode', 'value': '会计主体编码' },
                    { prop: 'accountNameLike', 'value': '会计主体名称' }
                ],
                tableConfig: [
                    { prop: 'contractName', 'value': '合同名称' },
                    { prop: 'accountName', 'value': '会计主体名称' },
                    { prop: 'accountCode', 'value': '会计主体编码' },
                    { prop: 'contractCode', 'value': '合同单据编码' },
                    { prop: 'paymentTermsName', 'value': '付款条件' },
                    { prop: 'businessTypeName', 'value': '供应商业务类型' }
                ],
                method: 'post',
                prefix: '/api-antms/',
                advanceUrl: 'transport/lsrm/searchTransUnit',
                cbParams: [
                    'paymentTerms',
                    'contractCode#transportContractNo',
                    'contractName#transportContractName',
                    'accountCode#transUnitCode',
                    'accountName#transUnitName',
                    'businessType#supplierBusinessType'
                ],
                advanceCascade: 'carrierCode#suppliersCode,siteCode'
            },
            storageOrder: true, // 搬仓订单勾选框（不需要传给后端，只做展示）
            kitchenCount: '', // 厨热订单数（不需要传给后端，只做展示）
            loading: false
        };
    },
    mounted () {
        this.getDicData();
        const propertiesToAssign = ['standardCost', 'iflowId'];
        this.assignProperties(this.componentsData, this.form, propertiesToAssign);
        this.kitchenCount = this.componentsData.kitchenOrderCount;
        this.form.transportationCost = +this.componentsData.natureType === 1 ? this.componentsData.ntpCost : this.componentsData.transportationCost;
        this.form.taxRate = this.isValidValue(this.componentsData.taxRate) ? this.componentsData.taxRate : '9';
        this.getLsrmCostSearch();
    },
    computed: {
        disableFlag () {
            if (this.componentsData.iflowStatus && this.componentsData.businessIflowStatus) {
                return true;
            } else if (!this.componentsData.iflowStatus && !this.componentsData.businessIflowStatus) {
                return false;
            } else if (this.componentsData.iflowStatus && !this.componentsData.businessIflowStatus) {
                return this.form.contractOut !== '3';
            } else {
                return this.form.contractOut === '3';
            }
        }
    },
    methods: {
        dialogClose () {
            this.$emit('components-close');
        },
        async getDicData () {
            const dict = await dictWithUrl('BID_PAYMENT_TERMS');
            this.dictData = dict.data.BID_PAYMENT_TERMS;
        },
        /**
         * @description: 高级下拉选中的回调
         * @param {*} data 选中的数据
         * @return {*}
         */
        getSelectValue (data) {
            this.form.contractOut = data.contractOut || '';
            if (data.contractOut === '3') {
                this.form.taxRate = '';
                this.form.transportationIncome = this.componentsData.kitchenTransportIncome;
            } else {
                this.componentsData.transportationIncome && (this.form.transportationIncome = this.componentsData.transportationIncome);
            }
        },

        /**
         * @description: 将源对象的指定项赋值给目标对象，即实现表单数据初始化
         * @param {Object} source 源对象
         * @param {Object} target 目标对象
         * @param {Array} properties 指定键的集合
         * @return {*}
         */
        assignProperties (source, target, properties) {
            for (const prop of properties) {
                if (source.hasOwnProperty(prop)) {
                    target[prop] = source[prop];
                }
            }
        },
        /**
         * @description 获取目标成本
        */
        getLsrmCostSearch () {
            const initDataArr = ['contractOut', 'transportContractNo', 'transportContractName', 'paymentTerms', 'transUnitCode', 'transUnitName', 'supplierBusinessType', 'siteCode', 'carrierCode'];
            lsrmCostSearch({ dispatchNo: this.componentsData.dispatchNo })
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.assignProperties(res.data, this.form, initDataArr);
                        this.form.standardCost = res.data.totalTargetCost;
                        this.form.transportationIncome = this.form.contractOut === '3'
                            ? this.componentsData.kitchenTransportIncome
                            : this.componentsData.transportationIncome;
                    } else {
                        this.$message.warning(res.msg);
                    }
                })
                .finally(() => {
                    this.$refs.performanceCommonDialog.show();
                });
        },
        // 现汇税率基础数据
        getTaxRateValue (data) {
            this.form.taxRate = data.taxRate;
        },
        getVehicleCardValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
        },
        isValidValue (value) {
            if (value === undefined || value === null || value === '') {
                return false;
            }
            return true;
        },
        validateContractOut (rule, value, callback) {
            if (!value) {
                callback(new Error('合同外场景不能为空'));
            } else if (this.componentsData.freightBasis !== '40' && +value === 1 && +this.componentsData.natureType === 1) {
                callback(new Error('本单为法人供应商竞价单，合同外场景必须包含成本。'));
            } else {
                callback();
            }
        },
        /**
         * @description: 运输收入 校验方法，运输收入不能为空，仅可输入数字，不能为0，支持小数点后两位；为搬仓订单时，可以为0，反之，不可为0
         * @param {Object} rule 当前校验规则
         * @param {String} value 当前值
         * @param {Function} callback 回调
         * @return {*}
         */
        validateTransportationIncome (rule, value, callback) {
            const _verify = /^\d+(\.\d{1,2})?$/;
            // 判断当前值的绝对值，是否小于最小精度，即 判断，当前数据的真实值，是否为0
            const isZero = Math.abs(Number(value)) < Number.EPSILON;
            if (value === null || value === undefined || value === '') {
                callback(new Error('运输收入不能为空'));
            } else if (this.componentsData.freightBasis !== '40' && isZero) {
                // freightBasis 10:轻货  20:散装  30:带托  40:搬仓  00:重货
                callback(new Error('运输收入不能为0'));
            } else if (!_verify.test(value)) {
                callback(new Error('仅可输入数字，支持小数点后2位'));
            } else {
                callback();
            }
        },
        /**
         * @description: 运输成本 校验方法，运输成本不能为空，仅可输入数字，不能为0，支持小数点后两位
         * @param {Object} rule 当前校验规则
         * @param {String} value 当前值
         * @param {Function} callback 回调
         * @return {*}
         */
        validateTransportationCost (rule, value, callback) {
            const _verify = /^\d+(\.\d{1,2})?$/;
            // 判断当前值的绝对值，是否小于最小精度，即 判断，当前数据的真实值，是否为0
            const isZero = Math.abs(Number(value)) < Number.EPSILON;
            if (value === null || value === undefined || value === '') {
                callback(new Error('运输成本不能为空'));
            } else if (isZero) {
                callback(new Error('运输成本不能为0'));
            } else if (!_verify.test(value)) {
                callback(new Error('仅可输入数字，支持小数点后2位'));
            } else {
                callback();
            }
        },
        // 保存
        async saveBtn () {
            const isKitchenHeat = this.form.contractOut === '3';
            if (isKitchenHeat && +this.kitchenCount === 0) {
                return this.$message.warning('未包含厨热订单，不允许发起厨热事业部收入分摊');
            }
            if (isKitchenHeat && this.componentsData.businessIflowUrl) {
                return this.$message.warning('已发起厨热事业部收入分摊的订单，不允许重复发起');
            }
            if (this.componentsData.freightBasis !== '40' && !isKitchenHeat && ['P'].includes(this.componentsData.iflowStatus)) {
                return this.$message.warning('非搬仓订单，合同外审批通过后，不允许重复发起');
            }
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    const param = {
                        ...this.form,
                        dispatchNo: this.componentsData.dispatchNo
                    };
                    const api = isKitchenHeat ? iflowCreateKitchen : createWhitoutzdc;
                    this.loading = true;
                    api(param).then((res) => {
                        if (res && +res.code === 0) {
                            this.$message.success('操作成功');
                            this.dialogClose();
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
/deep/.el-form-item__content .el-input-group {
    vertical-align: middle;
}

.el-form-item__label {
    width: 130px;
}

.toolTips {
    color: red;
    margin-left: 20px;
}

.bottom-btn {
    display: flex;
    justify-content: flex-end;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
</style>
